import React from 'react';

const PercentageCircle = ({ percentage, label, color, onClick }) => {
  // fixed virtual size the SVG coordinate system is drawn in
  const baseSize = 150;
  const stroke = 8;
  const radius = baseSize / 2;
  const normalizedRadius = radius - stroke * 2;
  const circumference = normalizedRadius * 2 * Math.PI;
  const strokeDashoffset = circumference - (percentage / 100) * circumference;

  return (
    <svg
      viewBox={`0 0 ${baseSize} ${baseSize}`}
      onClick={onClick}
      style={{ cursor: 'pointer', width: '100%', height: 'auto' }}
    >
      <circle
        stroke="#d3d3d3"
        fill="transparent"
        strokeWidth={stroke}
        r={normalizedRadius}
        cx={radius}
        cy={radius}
      />
      <circle
        stroke={color}
        fill="transparent"
        strokeWidth={stroke}
        strokeDasharray={`${circumference} ${circumference}`}
        style={{ strokeDashoffset }}
        r={normalizedRadius}
        cx={radius}
        cy={radius}
      />
      <text
        x="50%"
        y="50%"
        dy=".3em"
        textAnchor="middle"
        fontSize="24px"
        fill={color}
      >
        {label}
      </text>
    </svg>
  );
};

export default PercentageCircle;
